<script setup lang="ts">
// Static illustration for the "Custom domain" landing section: Ava's real page
// (profile card as DefaultLayout renders it) served from a domain she owns.

withDefaults(defineProps<{
  /** Drop the outer framed panel, for use inside a card that already frames it */
  bare?: boolean
}>(), { bare: false })
</script>

<template>
  <div
    aria-hidden="true"
    class="flex w-full select-none flex-col pointer-events-none"
    :class="bare ? '' : 'rounded-2xl border border-default bg-elevated/30 p-5 sm:p-8 shadow-(--surface-shadow)'"
  >
    <div class="mx-auto flex w-full max-w-md flex-1 flex-col overflow-hidden rounded-xl border border-(--mock-card-border) bg-(--mock-card-solid) shadow-xl shadow-black/10">
      <!-- Browser chrome -->
      <div class="flex items-center gap-3 border-b border-(--mock-card-border) px-3.5 py-2.5">
        <div class="flex shrink-0 gap-1.5">
          <span class="size-2.5 rounded-full bg-rose-400/70" />
          <span class="size-2.5 rounded-full bg-amber-400/70" />
          <span class="size-2.5 rounded-full bg-green-400/70" />
        </div>
        <div class="flex flex-1 items-center gap-1.5 rounded-md bg-(--mock-tile-bg) px-2.5 py-1">
          <UIcon
            name="i-lucide-lock"
            class="size-3 text-green-500"
          />
          <span class="text-xs font-medium text-(--mock-text)">ava.gg</span>
        </div>
      </div>

      <!-- The page itself -->
      <MockPage
        bg-position="50% 60%"
        class="flex flex-1 items-center justify-center px-5 py-7"
      >
        <div class="mock-card w-full max-w-lg p-8 [zoom:0.72]">
          <MockProfile />
        </div>
      </MockPage>
    </div>
  </div>
</template>
